// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3X4h5","row":"styles_row__IhnqW"};